import apiService from './api';
import { formatQueryString } from '@/helpers';
import type { NotificationsRequestParams, NotificationsResponse } from '@/types';

const BASE_PATH = '/admin/church';

class ChurchDashboardService {
  getNotifications = async ({ churchId, cursor, limit, filter }: NotificationsRequestParams) => {
    const query = formatQueryString({ cursor, limit, filter });
    const response = await apiService.get<NotificationsResponse>(
      `${BASE_PATH}/${churchId}/dashboard/notifications${query}`
    );
    return response.data;
  };

  approveNotification = async ({ churchId, id }: { churchId: string; id: string }) => {
    const response = await apiService.put<void>(`${BASE_PATH}/${churchId}/dashboard/notifications/${id}/approve`, {});
    return response.data;
  };

  rejectNotification = async ({ churchId, id }: { churchId: string; id: string }) => {
    const response = await apiService.put<void>(`${BASE_PATH}/${churchId}/dashboard/notifications/${id}/reject`, {});
    return response.data;
  };

  dismissNotification = async ({ churchId, id }: { churchId: string; id: string }) => {
    const response = await apiService.put<void>(`${BASE_PATH}/${churchId}/dashboard/notifications/${id}/dismiss`, {});
    return response.data;
  };

  dismissAllNotifications = async ({ churchId }: { churchId: string }) => {
    const response = await apiService.put<void>(`${BASE_PATH}/${churchId}/dashboard/notifications/dismiss-all`, {});
    return response.data;
  };

  getFavoriteChurchesCount = async (churchId: string) => {
    const response = await apiService.get<{ count: number }>(
      `${BASE_PATH}/${churchId}/dashboard/favorite-churches/count`
    );
    return response.data;
  };
}

export default new ChurchDashboardService();
